import React from 'react';
import styles from './login.module.scss';

const IntroLog = () => {
  return (
    <div className={styles.introContainer}>
      <div className="text-4xl flex flex-col items-center justify-center h-screen">
        <div className={styles.introText}>
          <span className="font-extrabold block">Innovation</span>
          <span className="font-extrabold block">distinguishes</span>
          <span className="font-extrabold block">between a leader</span>
          <span className="font-extrabold block">and a follower.</span>
        </div>
      </div>
    </div>
  );
};
export default IntroLog;
